/**
 * Plans and Services view related Actions
 */
export const POLICIES_AND_MODS_POLICIES_FILTER_RESET = 'POLICIES_AND_MODS_POLICIES_FILTER_RESET';
export function pcPoliciesAndModsPoliciesFilterReset() {
  return {
    type: POLICIES_AND_MODS_POLICIES_FILTER_RESET,
  };
}

export const POLICIES_AND_MODS_EX_MODS_FILTER_RESET = 'POLICIES_AND_MODS_EX_MODS_FILTER_RESET';
export function pcPoliciesAndModsExModsFilterReset() {
  return {
    type: POLICIES_AND_MODS_EX_MODS_FILTER_RESET,
  };
}

export const POLICIES_AND_MODS_FILTER_UPDATED = 'POLICIES_AND_MODS_FILTER_UPDATED';
export function pcPoliciesAndModsFilterUpdated(selectedValues, name) {
  return {
    type: POLICIES_AND_MODS_FILTER_UPDATED,
    selectedValues,
    name,
  };
}

export const POLICIES_AND_MODS_FILTER_RESET = 'POLICIES_AND_MODS_FILTER_RESET';
export function pcPoliciesAndModsFilterReset() {
  return {
    type: POLICIES_AND_MODS_FILTER_RESET,
  };
}

export const POLICIES_AND_MODS_TOGGLE_FILTER = 'POLICIES_AND_MODS_TOGGLE_FILTER';
export function pcPoliciesAndModsToggleFilter(event, expanded, filterName) {
  return {
    type: POLICIES_AND_MODS_TOGGLE_FILTER,
    filterName,
    expanded,
  };
}
